import cn from "classnames";
import PanelTemplate from "components/shared/profile/panel";
import React from "react";
import { showFuelLimitSettings, updateFuelLimitSettings } from "sources/profile/organization";
import { config, initialState } from "./config";

class FuelLimitSettings extends PanelTemplate {
    state = {
        data: { actualLiquidDataRange: "" },
        isValid: true,
    };

    componentDidMount() {
        showFuelLimitSettings().then((data) => this.setState({ data, initial: { ...data } }));
    }

    componentDidUpdate() {
        return undefined;
    }

    update = () => {
        const { data } = this.state;
        if (!this.isValidForm(data)) {
            return this.setState({ isValid: false });
        }
        return updateFuelLimitSettings(data).then((res) => {
            if (!res) {
                this.setState({ isValid: false });
            }
            this.setState({ shouldUpdate: false });
        });
    };

    renderBody = () => {
        const { editable, config } = this.props;
        const { actualLiquidDataRange } = config;
        return this.renderField({ ...actualLiquidDataRange, disabled: !editable });
    };

    render() {
        const cname = cn("card card-body mb-3", {
            "border-danger": !this.state.isValid,
        });
        return (
            <div className={cname}>
                <div className="row">
                    <div className="col-sm-4">
                        <h5>Настройки топливных лимитов</h5>
                    </div>
                    <div className="col-sm-8">
                        {this.renderBody()}
                        {this.renderButton()}
                    </div>
                </div>
            </div>
        );
    }
}

const ConfiguredPanel = (props) => <FuelLimitSettings {...props} config={config} initialState={initialState} />;

export default ConfiguredPanel;
